<template>
  <div class="main-vaa">
    <div class="flags">
      <b-button @click="changeLanguage('pt_BR')" variant="link">
        <img src="@/assets/img/auto_atendimento/brazil-square.png" width="30" alt="Bandeira do Brasil">
      </b-button>
      <b-button @click="changeLanguage('en')" variant="link">
        <img src="@/assets/img/auto_atendimento/eua-square.png" width="30" alt="United States Flag">
      </b-button>
      <b-button @click="changeLanguage('es')" variant="link">
        <img src="@/assets/img/auto_atendimento/spain-square.png" width="30" alt="Bandera Española">
      </b-button>
    </div>
    <div class="container text-gray">
      <router-view />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "Layout",
  methods: {
    changeLanguage(lang) {
      Cookies.set('user_language', lang)
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-vaa {
  min-height: 100vh;
  display: flex;
  background-color: #e2e2e2;

  .flags {
    position: absolute;
    right: 0;
    @media screen and (max-width: 768px) {
      justify-content: center;
      margin-bottom: 2rem;
    }
  }

  ::v-deep.strong-shadow {
    box-shadow: rgba(50, 50, 93, 0.25) 0 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset !important;
  }
}
::v-deep.text-gray {
  color: slategray !important;
}

::v-deep.border-left-primary {
  border-left: .25rem solid #4e73df !important;
}

::v-deep.border-left-secondary {
  border-left: .25rem solid #858796 !important;
}

::v-deep.border-left-success {
  border-left: .25rem solid #1cc88a !important;
}

::v-deep.border-left-warning {
  border-left: .25rem solid #f6c23e !important;
}

::v-deep.border-left-danger {
  border-left: .25rem solid #e74a3b !important;
}

::v-deep.b-radius-0 {
  border-radius: 0 !important;
}
</style>
